import { getStore as getCLPStore } from '../store/store';
import CLPLabel from 'owa-mail-store/lib/store/schema/CLPLabel';

export default function(): CLPLabel {
    const { userLabels } = getCLPStore();
    return getDefaultLabelFromList(userLabels);
}

function getDefaultLabelFromList(labels: CLPLabel[]) {
    for (let i = 0; i < labels.length; i++) {
        if (labels[i].isDefault) {
            return labels[i];
        }
        const defaultLabelInSubMenu = getDefaultLabelFromList(labels[i].children);
        if (defaultLabelInSubMenu) {
            return defaultLabelInSubMenu;
        }
    }
    return null;
}
